module.exports = __webpack_public_path__ + "static/media/undraw_cancel_u1it.6b2d075f.svg";